import { Box, TableContainer } from "@mui/material";
import styled from "styled-components";
import Dialog from '@mui/material/Dialog';

export const ManageBundleWrapper = styled(Box)`
font-family: 'Noto Sans', sans-serif;
background-color: #eff6ff;
.tableHeaderRight.d-flex {
        justify-content: space-between;     
        margin-top:5%;
        margin-left:0.2%;
        .buttonBox {
            display: flex;
            gap: 10px;
        }

        h4 {
            font-size: 20px;
            color: #1B4A83;
            font-weight: 600;
            font-family: 'Noto Sans', sans-serif;
        }  
        
        .btnMyRequest:hover, .btnMyRequest-active{
        color: rgb(27, 74, 131) !important;    
        text-decoration: underline;
        border-color: rgb(27, 74, 131) !important;
        border-radius: 3px;
        }
        
        .myRequestContainer:hover{
        border-color: rgb(27, 74, 131) !important;
        border-radius: 3px;
        }       
    }
.searchAndDropdownContainer{
    display: flex;    
}
.searchBox{    
    margin-left:0.2%;
}
.crmInfo{
    margin-left:1%;
    width:20%;
    display:flex;
    gap:5%;
    font-weight: 800;
    font-family: 'Noto Sans', sans-serif;
}
.opportunityDropdown{
    width:20%;
    gap:5%;
    display:flex;
    align-self: flex-end;
    margin: 0 auto !important;
}

.customDropdown{
    width:40%;
}

.parent-accordian{
    position: "relative",    
    zIndex: 0,
}

.backdrop: {
    position: "absolute"
  }

`;

export const BundleQuotesWrap = styled(Box)`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  width: 100%;
  .bundleHeadingBox {
    background: #1b4a83;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    color: white;
    text-transform: uppercase;
    height: 30px;
    border-radius: 5px 5px 0px 0px;
  }
`;
export const DropdownWrap = styled(Box)`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 95%;
  flex-direction: column;
  margin: 50px auto;
  gap: 20px;
  font-family: sans-serif;
  .compareButton {
    width: 200px;
    background: #03715b;
    text-transform: capitalize;
    :hover {
      background: #03715b;
    }
  }
  .listAccTxt {
    color: #949494;
  }
  .listItemqq {
    border-bottom: 1px solid #bdcadb;
    height: 40px;
  }
  .noBundleText {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .currentNoData{
    min-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .chip {
    color: #2b578c;
    border-radius: 5px;
    width: 160px;
    border: 1px solid #1b4a83;
  }
  .buttonContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    text-align: left;
    margin-top: 10px;
    margin-bottom: 15px;
    gap: 10px;
  }
  .infoContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
  }
  .infoIcon {
    color: #1b4a83;
    font-size: 14px;
    padding-left: 2px;
  }
  .infotext {
    color: #1b4a83;
    font-size: 13px;
  }
  .bundleButton {
    width: 120px;
    background: #239155;
    text-transform: capitalize;
    :hover {
      background: #239155;
    }
  }
  .refreshButton {
    width: 120px;
    text-transform: capitalize;
    color: #1b4a83;
    border: 1px solid #1b4a83;
  }
`;
export const CurrentQuoteTableWrap = styled(TableContainer)`
.tableContainer{
  border-radius: 5px 0px 0px 5px !important;
    table{
     thead{
        background-color: #bdd0e9;
        text-wrap: nowrap;
        color:#2e598f;      
        tr{
            th{
                color: #2e598f;
                font-weight: bold;
                text-align: start;
                padding:12px;
      @media screen and (min-device-width: 1190px) and (max-device-width: 1288px) { 
    //  font-size: 12px;
     font-weight: 400;
     },
    }
  }
}
tbody{
  border:1px solid #1B4A83;
  td{
    padding:12px;
    text-wrap: balance;
  }
}
}  
}`;
export const CompareQuotesTableWrap = styled(TableContainer)`
.MuiTableCell-root{
  font-size:12px;
  border-bottom:none;
  padding:12px;
}
.tableContainer{
  border-radius: 5px 0px 0px 5px !important;
    padding-left:1px;
    table{
        // border:1px solid #1B4A83;
     thead{
        background-color: #bdd0e9;
        text-wrap: nowrap;
        color:#1b4a83;        
        tr{
            th{
                color: #1b4a83;
                font-weight: bold;
                text-align: start;
                padding:12px;
      @media screen and (min-device-width: 1190px) and (max-device-width: 1288px) { 
    //  font-size: 12px;
     font-weight: 400;

   }
  }
}
}
tbody{
  text-wrap:balance;
  padding:12px;
}
}
   
}


.css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
    opacity: 1;
    color: #fff;
}
.fixedcolumnHeaderone
    {
        position: sticky;
        left:0;   
        font-family: 'Noto Sans', sans-serif;
    }

    .dragColumnHeader
    {
        font-family: 'Noto Sans', sans-serif;
        padding:6px 10px;
        max-width:100px;
        min-width:100px;
    }
    .closeIcon {
      display:flex;
      gap:5px;
      align-items:center;
      cursor:pointer;
      margin-left:10px;
      // font-size:12px;
      color:#1b4a83;      
      .qtcheckbox{
        background: white;
        border-radius: 5px;
        height: 0px;
        width: 0px;
        color:#1b4a83;
      }

      .qtcheckbox-disabled{
        background: #E4E4E4;
        border-radius: 5px;
        height: 0px;
        width: 0px;
        color:#1b4a83;
      }
      
    }
    .greyBg{
      background-color:#f3f3f3;
    }

    .dragColumnHeaderBundle
    {
        background:#ffff00;
        color:black;
        font-family: 'Noto Sans', sans-serif;
        padding:6px 20px;
    }
    
 .MuiTableSortLabel-icon {
    opacity: 1;
    color:white;
    font-size:20px;
}

                .filterBar{
                    margin: -5px 8px;
                    font-size: 18px;
                        @media screen and (min-device-width: 1190px) and (max-device-width: 1288px) { 
    margin: -3px 8px;
 font-size: 16px;

 }
                }
            }
        }
     }
     tbody{
        text-wrap: nowrap;
        tr{
            td{
                text-align: start;
                svg{

                }
            }
            th{

            }
        }
    }

}

}
.totalRow{
  background:#bdd0e9;
}
.fixedColumnone{
  background:#bdd0e9;
  position: sticky;
  left:0; 
  z-index: 1;
  color: #1b4a83;
  font-weight: 600;
  max-width: 100px;
  width: 1px;
  min-width: 100px;
  padding: 6px 10px;
  text-wrap:balanced;
}

.fixedColumntwo{
  background:#bdd0e9;
  position: sticky;
  left:0; 
  z-index: 1;
  color: #1b4a83;
  font-weight: 600;
  max-width: 150px;
  width: 1px;
  min-width: 150px;
  padding: 6px 10px;
  text-wrap:balanced;
}

.fixedColumnoneBlank{
  color:transparent;
}

.fixedColumnoneWhite{
  background:#e4e8ee;
  position: sticky;
  left:0; 
  z-index: 1;
  font-weight: 600;
  max-width: 100px;
  width: 1px;
  min-width: 100px;
  padding: 6px 10px;
  text-wrap:balance;
}
.fixedHeader{
  position: sticky;
  left:0; 
  z-index: 1;
  font-weight: 600;
  max-width: 100px;
  width: 1px;
  min-width: 100px;
  padding: 6px 20px;
  borderBottom: 1px solid #b7c6d8;
  // font-size:12px;
  color:#1b4a83;
}
.dragColumn  {
  font-family: 'Noto Sans', sans-serif;
  padding: 6px 10px;
  max-width: 100px;
  min-width: 100px;
  space: pre-line;
  word-break: break-word;
  text-wrap: balance;
}

.MuiOutlinedInput-root{
  padding :0px;
}
.css-11xur9t-MuiPaper-root-MuiTableContainer-root{
  border-radius:5px 0px 0px 5px !important;
  height:200px;
}
.tabrowWhite{
  background-color:#fff;
  color:white;
  }
  .viewLink{
    display: flex;
    align-items: center;
    gap: 1px;
    cursor:pointer;
    // font-size:12px;
    text-decoration-color:#1b4a83;
    color:#1b4a83;
    width: fit-content;
  }
  .viewLink svg{
    font-size:15px;
  }
  .approveLink{
    color:#239155;
    text-decoration-color:#239155;
  }
  .inactiveLink{
    display: flex;
    align-items: center;
    color: grey;
    width: fit-content;
    gap:1px;
    text-decoration:underline;
    cursor: no-drop;
  }
  .inactiveLink svg{
    font-size:15px;
  }
.tabrow{
  min-height:33px;
background-color:#bdd0e9;
color:white;
}
`;
export const CurrentQuoteTableBox = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 10px 0px 10px 0px;
  .noquotecell {
    height: 80px;
  }
  .noquotetext {
    margin-left: 16%;
  }
  .paginationContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h6 {
      color: #1b4a83;
      font-weight: 600;
      font-family: "Noto Sans", sans-serif;
      span {
        font-size: 14px;
        font-weight: 500;
        color: #000;
        padding-left: 6px;
        font-family: "Noto Sans", sans-serif;
      }
    }
    button {
      margin: 10px 0;
      border-radius: 2px;
      font-family: "Noto Sans", sans-serif;
    }
  }
  .noQuotesContainer {
    width: 100%;
    background-color: white;
    border: 1px solid #1b4a83;
    border-radius: 0px 5px 5px 5px;
    h2 {
      color: rgb(27, 74, 131);
    }
  }
  .sidecontainer {
    height: 48.3px;
    background-color: rgb(27, 74, 131);
    border-radius: 0px 5px 0px 0px;
    z-index: 1;
    width: 100%;
    padding-left: 10px;
    position: relative;
    left: -9px;
    top: -1px;
  }
  .noDataImage {
    width: 25%;
    height: 25%;
    object-fit: cover;
    margin-top: 100px;
  }
`;
export const ViewPrivilegesWrapper = styled(Dialog)`
height:100%;
.css-twia2z-MuiPaper-root-MuiDialog-paper{
  max-width:70%;
  width:fit-content;
  min-width:444px
}
.customDialogTitle {
  background-color: #1b4a83;
  text-align: center;
  color: #fff;
  font-size:14px;
}
.customDialog {
  text-align: center;
  color: #000;
  .roleBox {
    h5 {
      font-weight: 600px;
      font-size: 14px;
      color: #1b4a83;
      //padding: 0 20px 0 0;
    }
  }
  ul
  {
    list-style-type:none;
    font-size: 13px;
    padding:0px;
  }
  .customDropdown {
    text-align: left;
    width: 90%;
    padding-top: 10px;
  }
  span.error {
    color: #d32f2f;
    line-height: 2;
    font-weight: 400;
  }
  span.red {
    color: #ff0000;
  }
  .errorInput {
    border: 1px solid #ff0000;
    border-radius: 5px;
  }
  .inputform {
    width: 100%;
    padding-top: 10px;
    .formValue {
      width: 90%;
    }
  }
}
.dialogbutton {
  text-align: center;
  display: block;
  margin-bottom: 10px;

  .confirmButton {
    text-align: center;
    background-color: #1b4a83;
    width: 25%;
  }
  .rightButton {
    text-align: center;
    color: #1b4a83;
    width: 25%;
    border-color: #1b4a83;
  }
}
.samRecBoxData{
  border: 1px solid #8080808f;
  margin-top: 20px;
  min-height: 350px;
  max-height: 350px;
  overflow: auto;
  max-width: 700px;
  min-width: 600px;
  text-align: left;
  padding: 5px;
}
.samRecBox{
  display:flex;
}
.samRecTexaArea{
  width:550px;
  margin-top:20px;
  font-family:Noto Sans;
  resize:none;
  :disabled{
    background-color:#fff;
  }
}
     
.searchInput{
  display: flex;
  align-items: center;
  gap: 20px;
}
`;